import {Component, OnInit} from '@angular/core';
import {availableModels} from "../availableModels";
import {LangChangeEvent, TranslateService} from "@ngx-translate/core";
import {Scip} from "../model/scip";
import {Part} from "../model/part";
import {ModelData} from "../model/modelData";
import {LocaleData} from "../model/localeData";

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit {

  constructor(private translate: TranslateService) {
  }

  selectedModel!: string;
  selectedYear!: string;

  availableModels = availableModels;
  availableModelYears: string[] = []
  localeData?: LocaleData;

  filteredParts: Part[] = []
  filteredScips: Scip[] = []

  yearMAp: { [key: string]: 'HC' | 'HY' | 'HX' } = {
    '2022': 'HX',
    '2023': 'HC',
    '2025': 'HY'
  }

  ngOnInit() {
    this.updateLocales();
    this.translate.onLangChange
      .subscribe((event: LangChangeEvent) => {
        this.updateLocales();
      });
  }

  updateLocales() {
    this.translate
      .get([
        'availablePartsHX',
        'availablePartsHC',
        'availablePartsHY',
        'availableScips',
        'gmsAftersales',
        'legalNotesLink',
        'dataProtectionLink',
        'contactLink',
      ])
      .subscribe((link: LocaleData) => {
        this.localeData = link;
        this.applyFilters();
      });
  }

  applyModelFilter(selectedValue: any) {
    this.selectedYear = '';
    (document.getElementById('years') as any).selectedIndex = 0;
    if (selectedValue.target.selectedIndex > 0) {
      this.availableModelYears = Object.keys(this.availableModels[this.selectedModel]);
    }
    this.applyFilters();
  }

  applyFilters() {
    const yearKey: 'HC' | 'HY' | 'HX' = this.yearMAp[this.selectedYear]
    const dataKey: 'availablePartsHC' | 'availablePartsHX' | 'availablePartsHY' = `availableParts${yearKey}`;

    this.filteredParts = []
    this.filteredScips = []

    if (this.selectedModel && this.selectedYear) {
      let modelData: ModelData = (this.availableModels[this.selectedModel][this.selectedYear])

      for (let partKey of modelData.parts) {
        const item = this.localeData?.[dataKey]?.[partKey];
        if (item) {
          const partNumber = item.partNumber;
          const pdfFileList = partNumber.map((el)=>{
            const language = this.translate.currentLang.toUpperCase();
            const pdfName = `${el}_${partKey}_${language}.pdf`;
            return pdfName;
          })
          this.filteredParts.push({
            ...item,
            pdfFileList,
          });
        } else {
          // console.error("No Part locales")
        }
      }
      for (let scipKey of modelData.scips) {
        if (this.localeData?.availableScips[scipKey]) {
          this.filteredScips.push(this.localeData?.availableScips[scipKey])
        } else {
          console.error("No Scip locales")
        }
      }
    }
    if ((document.getElementById('models') as any).selectedIndex <= 0) {
      (document.getElementById('models') as any).selectedIndex = 0;
      (document.getElementById('years') as any).selectedIndex = 0;
    }
  }

  clearFilters() {
    (document.getElementById('models') as any).selectedIndex = 0;
    (document.getElementById('years') as any).selectedIndex = 0;
    this.selectedModel = '';
    this.selectedYear = '';
    this.filteredParts = []
    this.filteredScips = []
  }

  getDocument(fileName: string, name: string): string {
    const yearKey: 'HC' | 'HY' | 'HX' = this.yearMAp[this.selectedYear];
    const fileUrl = `../../assets/pdfs/${yearKey}/${name}/${fileName}`;

    return fileUrl;
  }
}
